import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalService } from '@core/services/modal.service';

@Component({
  selector: 'app-lead-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './lead-modal.component.html'
})
export class LeadModalComponent {
  showPassword: boolean = false;

  constructor(public modalService: ModalService) {}

  toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }
}
